import type { Contact } from "@/lib/gql/__generated__/graphql";
import { ContactMessageSenderType } from "@/lib/gql/__generated__/graphql";

import { AdminMessage } from "./admin-message";
import { HostMessage } from "./host-message";
import { useAutoScrollToBottom } from "./use-auto-scroll-to-bottom";

type Props = {
	contact: Contact;
};

export const CONTACT_CHAT_SECTION_ROOT_ID = "contact-chat-section-root";

export const Chat = ({ contact }: Props) => {
	const { messages } = contact;

	useAutoScrollToBottom();

	return (
		<div className="max-h-[600px] overflow-y-auto" id={CONTACT_CHAT_SECTION_ROOT_ID}>
			{messages.map((message) => {
				const isAdmin = message.senderType === ContactMessageSenderType.Admin;

				return (
					<div key={message.createdAt} className="flex flex-col-reverse pb-10">
						{isAdmin ? <AdminMessage message={message} /> : <HostMessage message={message} />}
					</div>
				);
			})}
		</div>
	);
};

Chat.displayName = "Chat";
